var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDialArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#489F3F",
  d: "m26.418 34.368 2.061-2.04L16.217 19.98 28.583 7.737 26.539 5.68 12.112 19.963z",
  opacity: 0.6
})));
export { SvgDialArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIiBmaWxsPSJub25lIj4KICA8ZyBvcGFjaXR5PSIwLjYiPgogICAgPHBhdGggZD0iTTI2LjQxODQgMzQuMzY3N0wyOC40Nzk0IDMyLjMyNzFMMTYuMjE2NiAxOS45ODAyTDI4LjU4MjUgNy43MzcxOEwyNi41MzkgNS42Nzk2NEwxMi4xMTI0IDE5Ljk2MzRMMjYuNDE4NCAzNC4zNjc3WiIgZmlsbD0iIzQ4OUYzRiIvPgogIDwvZz4KPC9zdmc+";